// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"_N-z","carouselContainer":"aO-z"};